import { FC } from "react";
import GallerySlider from "components/GallerySlider/GallerySlider";

import { useLocation } from "react-router-dom";
import CarsListingModel from "models/CarsListingModel";
export interface FleetCardProps {
  className?: string;
  data?: any;
  size?: "default" | "small";
  simpleImg?: boolean;
  onClick?: any;
}

const FleetCard: FC<FleetCardProps> = ({
  size = "default",
  className = "",
  data,
  simpleImg = false,
  onClick,
}) => {
  const {
    id,
    fleet_photos,
    name,
    color,
    seats,
    avg_car_price_per_day,
    thumbnail_photo_url,
    increased_price,
  } = data!;
  const location = useLocation();

  // "% OFF" badge + struck-through original price when the fleet-list
  // payload carries a higher increased_price than the current
  // avg_car_price_per_day (undocketed, ported from Template's FleetCard).
  const increasedPriceNum = Number(increased_price);
  const currentPriceNum = Number(avg_car_price_per_day ?? 0);
  const hasDiscount =
    Number.isFinite(increasedPriceNum) &&
    increasedPriceNum > 0 &&
    increasedPriceNum > currentPriceNum &&
    currentPriceNum > 0;
  const discountPercent = hasDiscount
    ? Math.round(
        ((increasedPriceNum - currentPriceNum) / increasedPriceNum) * 100
      )
    : 0;

  const renderSliderGallery = () => {
    return (
      <div className="relative w-full">
        {/* {simpleImg ? ( */}
        <img
          src={
            // 1NOW-3011 / ONENOW-457: a car can have photos but no truthy
            // thumbnail_photo_url (or one already stored as an absolute URL) —
            // fall back to the placeholder instead of a broken/malformed src.
            fleet_photos &&
            fleet_photos.length > 0 &&
            thumbnail_photo_url?.includes("http")
              ? thumbnail_photo_url
              : fleet_photos && fleet_photos.length > 0 && thumbnail_photo_url
              ? `https://fleet-management-images-upload-be.s3.amazonaws.com/${encodeURIComponent(
                  thumbnail_photo_url
                )}`
              : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
          }
          alt={name}
          className="h-[200px] object-cover w-full"
        />

        {/* ) : (
          <GallerySlider
            uniqueID={`StayCard_${l_id}`}
            ratioClass="aspect-w-4 aspect-h-3 "
            galleryImgs={
              listing_images.length > 0
                ? listing_images.map((image) => image.path)
                : ["https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"]
            }
          />
        )} */}
        {/* <BtnLikeIcon isLiked={like} className="absolute right-3 top-3 z-[1]" /> */}
        {/* {saleOff && <SaleOffBadge className="absolute left-3 top-3" />} */}
      </div>
    );
  };

  const renderContent = () => {
    return (
      <div className={size === "default" ? "p-4 space-y-4" : "p-3 space-y-2"}>
        <div className="space-y-2">
          <div className="flex items-center justify-between gap-2">
            {/* {isAds && <Badge name="ADS" color="green" />} */}
            <h2
              className={`font-medium capitalize min-w-0 flex-1 ${
                size === "default" ? "text-lg" : "text-base"
              }`}
            >
              <p className="truncate w-full max-w-full">{name}</p>
            </h2>
            {hasDiscount && (
              <span className="shrink-0 text-sm font-bold tracking-wide text-red-600">
                {discountPercent}% OFF
              </span>
            )}
          </div>

          <span className=" text-sm">
            <span className="font-semibold">{seats}</span> seats{" "}
            <span className="font-semibold">{color}</span> color
          </span>
        </div>
        <div className="w-14 border-b border-neutral-100 dark:border-neutral-800"></div>
        <div className="flex justify-between items-center">
          <span className="text-base font-semibold">
            {hasDiscount && (
              <span className="block text-sm font-medium text-neutral-500 dark:text-neutral-400 line-through leading-tight">
                ${increasedPriceNum}
              </span>
            )}
            {avg_car_price_per_day ? "$" + avg_car_price_per_day : "$" + 0}

            {` `}
            {size === "default" && (
              <span className="text-sm text-neutral-500 dark:text-neutral-400 font-normal">
                /day
              </span>
            )}
          </span>
          {/* {!!reviewStart && (
            <StartRating reviewCount={reviewCount} point={reviewStart} />
          )} */}
        </div>
      </div>
    );
  };

  return (
    <div
      className={`nc-StayCard group relative bg-white dark:bg-neutral-900 border border-neutral-100 dark:border-neutral-800 rounded-2xl overflow-hidden will-change-transform hover:shadow-xl transition-shadow ${className}${
        location.pathname === "/available-car" ? "cursor-pointer" : ""
      }`}
      data-nc-id="StayCard"
      onClick={onClick}
    >
      {renderSliderGallery()}
      {/* <Link to={"/"}> */}
      {renderContent()}
      {/* </Link> */}
    </div>
  );
};

export default FleetCard;
